import { FlexLayout } from '@calendly/ui/components/flex-layout';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getLabelForKind } from '../utils';
const styledFlexLayoutCss = "ss752ri";
const StyledFlexLayout = forwardRef((props, ref) => <FlexLayout ref={ref} {...props} className={classNames(styledFlexLayoutCss, props.className)} />);
export const Label = ({
  icon,
  kind
}) => <StyledFlexLayout gap={4} direction="column">
    {icon}
    <BodyText size="medium" as="div">{getLabelForKind(kind)}</BodyText>
  </StyledFlexLayout>;

require("./label.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./label.js");